<template>
  <li :searchWord="searchWord" @click="search">{{searchWord}}</li>
</template>

<script>
export default {
  props: ['searchWord'],
  methods: {
    search: function(e) {
      this.$emit('searchThisItem', e.target.innerText);
    }
  }
}
</script>

<style scoped>
  li {
     display: inline-block;
     margin: 1.333vw;
     border-radius: 0.12rem;
     background-color: rgba(237,237,237,1);
     padding: 0.04rem 0.15rem 0.035rem 0.15rem;
     font-size: 0.13rem;
		 color: #333333;
  }
</style>
